module.exports = "/assets/landing-cf/how-it-works/arrow.png?kRAmuo9";